import { ME } from '@/graphql.gql';

export default {
  data() {
    return {
      me: {
        firstName: 'Persona',
        lastName: 'Incognito',
        email: 'persona.incognito@mail.com',
        vscId: '',
        vscSecret: '',
        vscBalance: {},
      },
    };
  },
  apollo: {
    me: {
      query: ME,
      update({ me }) {
        if (typeof me.vscBalance === 'string') {
          // eslint-disable-next-line no-param-reassign
          me.vscBalance = JSON.parse(me.vscBalance);
        }
        return me;
      },
      watchLoading(isLoading) {
        if (isLoading && !this.$wait.is('busy')) {
          this.$wait.start('busy');
        } else if (!isLoading && this.$wait.is('busy')) {
          this.$wait.end('busy');
        }
      },
    },
  },
  computed: {
    vscAccounts() {
      if (Object.keys(this.me.vscBalance).length === 0 && this.me.vscBalance.constructor === Object) {
        return [];
      }
      return Object.keys(this.me.vscBalance).sort();
    },
  },
};
